import {Option} from 'platform/components';

import {defaultTo, isNil} from 'ramda';

import {GetSupplierDiscountGroupsResponse} from '@dms/api/warehouse';

import {Nullish} from 'shared/web';

export const getOptionsFromSupplierDiscountGroups = (
  supplierDiscountGroups: GetSupplierDiscountGroupsResponse | Nullish
): Option[] => {
  if (isNil(supplierDiscountGroups?.discountGroupCode)) {
    return [];
  }

  return supplierDiscountGroups.discountGroupCode?.map((supplierDiscountGroup) => ({
    label: defaultTo('', supplierDiscountGroup?.code),
    value: supplierDiscountGroup?.discountGroupId,
  }));
};
